import SidebarRecursiveMenuItem from './SidebarRecursiveMenuItem';

const SidebarRecursiveMenu = ({ menuItems, currentLevel = 0, sidebarIsCollapsed }) => {
    return (
        <>
            {menuItems.map((menuItem) => (
                <SidebarRecursiveMenuItem
                    key={menuItem.label}
                    menuItem={menuItem}
                    currentLevel={currentLevel}
                    sidebarIsCollapsed={sidebarIsCollapsed}
                />
            ))}
        </>
    );
};

export default SidebarRecursiveMenu;
